module.exports = __webpack_public_path__ + "static/media/Sphinx.d90284d2.jpg";